export class FiltrosPlanejamentoSafra {
  FazendaId: number = null;
  SafraId: number = null;
  CulturaId: number = null;
  StatusSafra: number = null;
}
